import React from 'react'
import { breakpoints } from 'ui/acro'
import Carousel from 'components_v2/Home/SignedIn/common/components/Carousel/Carousel'
import { SeriesCard } from 'components_v1/SchemaSectionRenderer/common/components'
import { useUserContext } from 'context'

const SeriesResultsCarousel = ({ data }) => {
  const { user } = useUserContext() || {}
  const seriesData = data && data.series.top
  const transFormData = seriesData.reduce((acc, item) => {
    return [
      ...acc,
      {
        id: item.id,
        title: item.title,
        isFevIcon: false,
        url: item.url,
        coverPhoto: {
          url: item.thumbnailImage
        },
        primaryCategory: {
          title: item.category || ''
        },
        subcategory: {
          title: item.subcategory || ''
        },
        workoutCount: item.classesCount,
        coaches: item.coaches?.reduce((acc, coach) => {
          return [
            ...acc,
            {
              firstName: coach,
              lastName: ''
            }
          ]
        }, []),
        availabilityGating: item?.availabilityGating,
        membershipTier: user?.membershipTier
      }
    ]
  }, [])

  return (
    <Carousel
      card={SeriesCard}
      carouselTitle={'SeriesTopResults'}
      data={transFormData}
      mx={['16px', '16px', '16px', '0px']}
      breakpoints={{
        0: {
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        320: {
          slidesPerView: 1.7,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        375: {
          slidesPerView: 1.7,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        [breakpoints[1]]: {
          slidesPerView: 2.7,
          spaceBetween: 20,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        768: {
          slidesPerView: 2.7,
          spaceBetween: 20,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        [breakpoints[2]]: {
          slidesPerView: 3,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        }
      }}
    />
  )
}

export default SeriesResultsCarousel
